import { BI_BASE_URL } from '@app/contstants/endpoints';
import { api } from '@app/utils/api';
import { errorHandler } from '@app/utils/errorHandler';
import { parseFilenameFromContentDisposition, triggerBlobDownload } from '@app/utils/file';
import { useMutation } from '@tanstack/react-query';

type Params = {
  managerId: number;
  month: number;
  year?: number;
  order_by?: string;
  order_direction?: string;
  limit?: number;
  page?: number;
  export_xlsx?: boolean;
}

export const downloadManagerSalary = async (params: Params): Promise<void> => {
  const { managerId, month, year, order_by, order_direction, limit, page } = params;
  const response = await api.get<Blob>(`${BI_BASE_URL}/managers/manager/${managerId}/pay/${month}`, {
    params: {
      year: year ?? new Date().getFullYear(),
      order_by: order_by ?? 'hashrate',
      order_direction: order_direction ?? 'desc',
      limit: limit ?? 100,
      page: page ?? 1,
      export_xlsx: true,
    },
    responseType: 'blob',
  });

  const filename = parseFilenameFromContentDisposition(
    response.headers['content-disposition'],
    `manager-${managerId}-pay-${month}.xlsx`
  );
  const blob = new Blob([response.data], {
    type:
      response.headers['content-type'] ||
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  });
  triggerBlobDownload(blob, filename);
};

export const useDownloadManagersSalary = () => {
  const { mutateAsync, isPending, error } = useMutation({
    mutationFn: downloadManagerSalary,
    onError: error => errorHandler(error),
  });

  return {
    fetch: mutateAsync,
    isPending,
    error,
  };
};